export const OUT_OF_SCOPE = 'getCurrentInstance() returned null. Method must be called at the top of a setup() function.';
